// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1lZiO","infoBtn":"quickbooks_infoBtn__3ekFD","formBox":"quickbooks_formBox__F7yQw","formFooter":"quickbooks_formFooter__3eD2k"};